/**
 * Bridges WebSocket events to React Query invalidation.
 * When the backend pushes real-time events, this hook
 * automatically invalidates the relevant query caches so
 * screens using useDevices / useAlarms / etc. refresh.
 */
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import websocketService from '../services/websocket';
import { deviceKeys, alarmKeys } from './queries';
import logger from '../utils/logger';

export function useWebSocketQueryBridge() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const unsubAlarm = websocketService.subscribe('alarm', () => {
      logger.log('🔔 [WS→RQ] alarm event → invalidating alarm queries');
      queryClient.invalidateQueries({ queryKey: alarmKeys.all });
    });

    const unsubDeviceStatus = websocketService.subscribe('device-status', () => {
      logger.log('📡 [WS→RQ] device-status event → invalidating device queries');
      queryClient.invalidateQueries({ queryKey: deviceKeys.all });
    });

    const unsubDeviceUpdate = websocketService.subscribe('device-update', () => {
      logger.log('🔄 [WS→RQ] device-update event → invalidating device queries');
      queryClient.invalidateQueries({ queryKey: deviceKeys.all });
    });

    return () => {
      unsubAlarm();
      unsubDeviceStatus();
      unsubDeviceUpdate();
    };
  }, [queryClient]);
}
